"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightCode = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const code_colors_react_1 = require("code-colors-react");
exports.HighlightCode = React.memo(({ code, lang }) => {
    return React.createElement(code_colors_react_1.ColorTokens, { code: code, lang: lang, as: 'code' });
});
exports.default = exports.HighlightCode;
